const ImpressionList = [
  "やんちゃ",
  "おだやか",
  "ハッピー",
  "図々しい",
  "食欲旺盛",
  "好奇心旺盛",
  "神経質",
  "慎重派",
  "怖がりさん",
  "食べムラがある",
  "飼い主に甘えん坊"
]

export { ImpressionList }